import { render, staticRenderFns } from "./EditProductBrandComponent.vue?vue&type=template&id=af0fdb62&scoped=true"
import script from "./EditProductBrandComponent.vue?vue&type=script&lang=js"
export * from "./EditProductBrandComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0fdb62",
  null
  
)

export default component.exports